// Display labels for internal role keys. The `head_coach` role is shown as
// "admin" across the app (it grants full club-admin access); a user's custom
// title always wins when present.
const ROLE_DISPLAY = {
  head_coach: "admin",
  super_admin: "super admin",
  external_coach: "external coach",
};

export function roleLabel(roleOrUser) {
  if (typeof roleOrUser === "string") {
    return ROLE_DISPLAY[roleOrUser] || roleOrUser.replace("_", " ");
  }
  const u = roleOrUser || {};
  return u.title || ROLE_DISPLAY[u.role] || (u.role || "").replace("_", " ");
}
